import { render } from "./color.vue?vue&type=template&id=4f2dd94c"
import script from "./color.vue?vue&type=script&lang=js"
export * from "./color.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/color.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f2dd94c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f2dd94c', __exports__)) {
    console.log('reload')
    api.reload('4f2dd94c', __exports__)
  }
  
  module.hot.accept("./color.vue?vue&type=template&id=4f2dd94c", () => {
    console.log('re-render')
    api.rerender('4f2dd94c', render)
  })

}


export default __exports__